<div class="slider-list">
  <app-slider
    #slider
    [collection]="collection"
    [renderWithZeroItems]="true"
    [title]="list.name"
    [items]="records"
    [featured]="true"
    [preview]="true"
    [placeholder]="loading"
    [showActions]="true"
    [showSubheader]="true"
    [indentTop]="false"
    [showEmptyBoard]="showEmptyBoard"
    [extraHeaderMargin]="false"
    [loadedView]="'USER_LISTS'">
    <ng-template appSliderActions>
      <div class="actions-wrapper">
        <button *ngIf="!showEmptyBoard" mat-flat-button class="only-icon hide-tablet" (click)="showList()">
          <span class="odilo-icon">navigate_next</span>
        </button>
        <button *ngIf="!showEmptyBoard" mat-flat-button class="accent transparent hide-mobile" (click)="showList()">
          {{ 'general.viewMore' | translate }}
        </button>
        <button
          mat-flat-button
          class="only-icon hide-mobile"
          [matMenuTriggerFor]="actionsMenu"
          [attr.aria-label]="'general.viewMore' | translate">
          <span class="odilo-icon">more_vertical</span>
        </button>
        <mat-menu #actionsMenu="matMenu">
          <button *ngIf="forListSubscriptions" mat-menu-item (click)="unfollowList()">
            <span class="odilo-icon">unfollow</span>
            {{ 'lists.unfollow' | translate }}
          </button>
          <button *ngIf="!forListSubscriptions" mat-menu-item (click)="editList()">
            <span class="odilo-icon">edit</span>
            {{ 'general.edit' | translate }}
          </button>
          <button *ngIf="!forListSubscriptions" mat-menu-item (click)="addTitles()">
            <span class="odilo-icon">add</span>
            {{ 'lists.addTitles' | translate }}
          </button>
          <button *ngIf="!list?.privateList" mat-menu-item (click)="copyToClipboard()">
            <span class="odilo-icon">link</span>
            {{ 'tooltip.copyLink' | translate }}
          </button>
          <button *ngIf="!forListSubscriptions" mat-menu-item (click)="showDeleteListDialog.set(true)">
            <span class="odilo-icon">delete</span>
            {{ 'lists.remove' | translate }}
          </button>
        </mat-menu>
      </div>
    </ng-template>

    <ng-template appSliderSubheader>
      <div class="slider-list__subheader">
        <span *ngIf="!forListSubscriptions"
          >{{ (list.privateList ? 'lists.private' : 'lists.public') | translate }} ·
        </span>
        <span
          >{{ list?.items.length }} {{ (list?.items.length === 1 ? 'general.item' : 'general.items') | translate
          }}</span
        >
        <div class="followers" *ngIf="!list.privateList">
          <span class="odilo-icon">followers</span>
          <span class="followers__number"
            >{{ list.followers }} {{ (list.followers === 1 ? 'lists.follower' : 'lists.followers') | translate }}</span
          >
        </div>
      </div>
    </ng-template>
  </app-slider>

  <div class="slider-component__empty" *ngIf="showEmptyBoard">
    <div class="slider-component__empty__content">
      <ng-container *ngIf="!forListSubscriptions">
        <span class="hide-mobile">{{ 'lists.noElements' | translate }}</span>
        <button mat-flat-button class="accent transparent" (click)="addTitles()">
          {{ 'lists.addElements' | translate }}
        </button>
      </ng-container>
      <ng-container *ngIf="forListSubscriptions">
        <span>{{ 'lists.noElements' | translate }}</span>
      </ng-container>
    </div>
  </div>
</div>

<opac-confirmation-dialog
  [acceptLabel]="'general.delete'"
  [open]="showDeleteListDialog()"
  [title]="'lists.empty.confirm.title' | translate"
  (accept)="deleteList()"
  (cancel)="showDeleteListDialog.set(false)">
  <p [innerHTML]="descriptionToDeleteListDialog() | translate"></p>
</opac-confirmation-dialog>
